export const types = Object.freeze({
    RESET_TRIP_ANALYZER: 'tripAnalyzer/RESET',
    SET_QUERY: 'tripAnalyzer/SET_QUERY',
    SET_COMPARE_ENABLED: 'tripAnalyzer/SET_COMPARE_ENABLED',
    SET_TRIP_ORDER: 'tripAnalyzer/SET_TRIP_ORDER',
    OPEN_TSP_PANEL: 'tripAnalyzer/OPEN_TSP_PANEL',
    CLOSE_TSP_PANEL: 'tripAnalyzer/CLOSE_TSP_PANEL',

    SERVICE_DATES_REQUEST: 'tripAnalyzer/SERVICE_DATES_REQUEST',
    SERVICE_DATES_SUCCESS: 'tripAnalyzer/SERVICE_DATES_SUCCESS',
    SERVICE_DATES_ERROR: 'tripAnalyzer/SERVICE_DATES_ERROR',

    CATALOG_REQUEST: 'tripAnalyzer/CATALOG_REQUEST',
    CATALOG_SUCCESS: 'tripAnalyzer/CATALOG_SUCCESS',
    CATALOG_ERROR: 'tripAnalyzer/CATALOG_ERROR',

    COLUMNS_REQUEST: 'tripAnalyzer/COLUMNS_REQUEST',
    COLUMNS_SUCCESS: 'tripAnalyzer/COLUMNS_SUCCESS',
    COLUMNS_ERROR: 'tripAnalyzer/COLUMNS_ERROR',

    TIMELINE_REQUEST: 'tripAnalyzer/TIMELINE_REQUEST',
    TIMELINE_SUCCESS: 'tripAnalyzer/TIMELINE_SUCCESS',
    TIMELINE_ERROR: 'tripAnalyzer/TIMELINE_ERROR',

    TSP_EVENTS_REQUEST: 'tripAnalyzer/TSP_EVENTS_REQUEST',
    TSP_EVENTS_SUCCESS: 'tripAnalyzer/TSP_EVENTS_SUCCESS',
    TSP_EVENTS_ERROR: 'tripAnalyzer/TSP_EVENTS_ERROR',
});

export const catalogKinds = Object.freeze({
    ROUTES: 'routes',
    DIRECTIONS: 'directions',
    TRIPS: 'trips',
});
